import { Component, OnInit, Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";

@Component({
  selector: "app-dialog-busqueda-empresa-sucursal",
  templateUrl: "./dialog-busqueda-empresa-sucursal.component.html",
  styleUrls: ["./dialog-busqueda-empresa-sucursal.component.css"],
})
export class DialogBusquedaEmpresaSucursalComponent implements OnInit {
  empresaSucursal = [];
  constructor(
    @Inject(MAT_DIALOG_DATA) public dataDialog: any,
    private dialogRef: MatDialogRef<DialogBusquedaEmpresaSucursalComponent>
  ) {
    this.empresaSucursal = this.dataDialog;
  }

  ngOnInit() {}

  clienteSeleccionado(empresaSucursal) {
    //console.log(persona);
    this.dialogRef.close(empresaSucursal);
  }
}
